import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
} from '@material-ui/core';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useNavigate } from 'react-router';
import { paths } from '../../../routes';

export const CompleteAccountSetupDialog: React.FC<{
    openCompleteProfileDialog: boolean;
    handleCloseDialog: () => void;
}> = observer(({ openCompleteProfileDialog, handleCloseDialog }) => {
    const navigate = useNavigate();

    return (
        <>
            <Dialog
                open={openCompleteProfileDialog}
                onClose={handleCloseDialog}
                aria-labelledby='alert-dialog-title'
                aria-describedby='alert-dialog-description'
            >
                <DialogTitle id='alert-dialog-title'>
                    Complete Profile &amp; ID Verification
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id='alert-dialog-description'>
                        You have not completed your account setup. To ensure you have the best
                        experience and access to Realhaus features, please finalize your account
                        setup.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialog} color='primary'>
                        Cancel
                    </Button>
                    <Button
                        onClick={() => {
                            handleCloseDialog();
                            navigate(paths.account.personalInfo);
                        }}
                        color='primary'
                        autoFocus
                    >
                        Continue
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
});
